module.exports = __webpack_public_path__ + "static/game-tournament-c9b9f42827867b89fce75c4cf4201b1d.jpg";